export const baseRoutes = {
  userBaseRoutes: "/",
  adminBaseRoutes: "/admin",
};